import type { MacroGuestFrame } from './input/MacroMouseEmitter';

export type { MacroGuestFrame };
export type MacroStepRunResult = { success: true } | { success: false; reason: string };

/** Compatibility boundary for persisted DSL settings. Execution belongs to the graph service. */
export class MacroStepRunner {
  public cancel(): void {}
  public async cancelAndWait(): Promise<boolean> { return true; }
  public async runSteps(steps: string[], _label = 'Macro', _frame?: MacroGuestFrame): Promise<MacroStepRunResult> {
    return steps.length ? { success: false, reason: 'macro_graph_migration_required' } : { success: true };
  }
}
